<template>
  <div>
    <p id="dashboardItemTitle">Envelope Status Report</p>
    <div class="columns mt-3">

      <div class="column is-3">
        <b-field custom-class="is-small"
                 :type="invalidDepartment == '' ? '' : 'is-danger'"
                 :message="invalidDepartment">
          <b-select placeholder="Select a Department" expanded v-model="formData.Department" @input="resetInvalidStatus('invalidDepartment')" >
            <option
                v-for="option in departmentList "
                :value="option.name"
                :key="option.id">
              {{ option.name }}
            </option>
          </b-select>
        </b-field>
      </div>

      <div class="column is-3">
        <b-field custom-class="is-small"
                 :type="invalidStatus == '' ? '' : 'is-danger'"
                 :message="invalidStatus">
          <b-select placeholder="Select a Status" expanded v-model="formData.Status" @input="resetInvalidStatus('invalidStatus')" >
            <option
                v-for="option in DocumentStatus "
                :value="option.name"
                :key="option.id">
              {{ option.name }}
            </option>
          </b-select>
        </b-field>
      </div>

      <div class="column is-2">
        <b-field
            custom-class="is-small"
            :type="invalidDateRange == '' ? '' : 'is-danger'"
            :message="invalidDateRange">
          <b-datepicker
              :range="true"
              :date-creator="generateDate"
              :max-date="new Date()"
              placeholder="Click to select..."
              icon="calendar-today"
              trap-focus
              v-model="selectedDateRange"
              @input="resetInvalidStatus('invalidDateRange')">
          </b-datepicker>
        </b-field>
      </div>

      <div class="column is-2">
        <b-field>
          <b-button class="is-dark" icon-left="file-clock" @click="validateAndSubmit()">Generate Report</b-button>
        </b-field>
      </div>

      <div class="column">
        <!--          <b-button class="mt-3" :loading="xlsxDownloading" @click="ReportDownload('XLSX')" :disabled="!exportButtonsEnabled" type="is-link" size="is-small is-outlined" icon-right="microsoft-excel"></b-button>-->
        <b-button class="ml-2 is-outlined" :loading="pdfDownloading" @click="ReportDownload('PDF')" :disabled="!exportButtonsEnabled" type="is-link"  icon-right="adobe-acrobat">Download</b-button>
      </div>

    </div>
    <div style="margin-top: 30px">
      <section v-if="!isLoading">
        <template v-if="tableRows.length < 1" >
          <div class="empty-indicator">
            <span class="icon has-text-grey-lighter is-normal">
                <i class="mdi mdi-information-outline mdi-24px"></i>
            </span>
            <span class="ml-2 has-text-grey-lighter">No records to display</span>
          </div>
        </template>
        <b-table
            v-else
            :data="tableRows"
            :paginated="isPaginated"
            :per-page="perPage"
            :current-page="currentPage"
            :pagination-simple="isPaginationSimple"
            :pagination-position="paginationPosition"
            :default-sort-direction="defaultSortDirection"
            :sort-icon="sortIcon"
            :sort-icon-size="sortIconSize"
            :hoverable="isHoverable"
            :bordered="isBordered"
            :striped="isStriped"
            :narrowed="isNarrowed"
            :sticky-header="stickyHeaders"

            pagination-size="is-small"
            default-sort="reference_id"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page">


          <b-table-column field="username" label="Username" sortable  v-slot="props" width="50" cellClass="has-text-left" >
            {{ props.row.username }}
          </b-table-column>

          <b-table-column field="name" label="Name" sortable  v-slot="props" width="50" cellClass="has-text-left">
            {{ props.row.name }}
          </b-table-column>

          <b-table-column field="department" label="Department" sortable  v-slot="props" width="50" cellClass="has-text-left">
            {{ props.row.department }}
          </b-table-column>

          <b-table-column field="status" label="Envelope Status" sortable  v-slot="props" width="50" cellClass="has-text-left">
            {{ props.row.status }}
          </b-table-column>


          <b-table-column field="created_at" label="Timestamp" sortable width="20"  v-slot="props" cellClass="has-text-left">
            {{ DateFormat(props.row.created_at)}}
          </b-table-column>

        </b-table>

      </section>

    </div>
  </div>
</template>
<script>

import axios from "axios";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export default {

  name:'envelopeStatus-report',

  data(){
    return{
      tableRows:[], // to store pending documents
      isLoading:false,
      departmentList:[],

      showTemplateDeleteModal:false,
      selectedDateRange:null,

      isPaginated: true,
      isHoverable: true,
      isBordered: false,
      isStriped: true,
      isNarrowed: false,
      isPaginationSimple: false,
      paginationPosition: 'bottom',
      defaultSortDirection: 'asc',
      sortIcon: 'arrow-up',
      sortIconSize: 'is-small',
      currentPage: 1,
      perPage: 10,
      stickyHeaders: true,

      template_id:'',
      maxDate:null,

      invalidDateRange:'',
      invalidDepartment:'',
      invalidStatus:'',

      DocumentStatus:[
        {id:0,name:'Completed'},
        {id:1,name:'Pending'},
        {id:2,name:'Declined'},
        {id:3,name:'Expired'}
      ],

      formData: {
        start_date: '',
        end_date: '',
        Department:null,
        Status:null,
      },

      xlsxDownloading:false,
      pdfDownloading:false,
      exportButtonsEnabled:false,

    }

  },

  beforeMount() {
    this.getDepartmentList()
  },

  methods:{

    DateFormat:function(date)
    {
      //date formatting
      var d = new Date(date)
      var datestring = d.getFullYear() + "-"+ (d.getMonth()+1) + "-"+ d.getDate();

      console.log(datestring);

      //hours formatting
      var hours = d.getHours();
      var minutes = d.getMinutes();
      var ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? '0'+minutes : minutes;
      var strTime = hours + ':' + minutes + ' ' + ampm;

      var dateTime = datestring +' : '+ strTime
      return dateTime

      // console.log('dateformat js'+datestring);
    },

    getDepartmentList:function (){
      var comp = this

      let formData = new FormData()
      formData.append('auth_token',comp.$root.agentAuthToken,)

      axios.post(comp.$base_url+'/agent/getDepartmentList',formData)
          .then(function (response) {
            console.log(response.data)
            comp.departmentList = response.data.data
          })
          .catch(function (error) {
            console.log(error)
            comp.$buefy.toast.open({
              message: "Failed to get filter data",
              type: "is-danger",
            });
          });
    },

    generateDate: function(){

      var date = new Date()
      return date

    },

    resetInvalidStatus: function(key){
      this[key] = ''
    },

    validateAndSubmit: function(){
      if(this.validateForm()){
        this.submitForm()
      }
    },

    validateForm: function(){
      var formIsValid = true


      if(this.selectedDateRange == null){
        this.invalidDateRange = 'This field cannot left blanks'
        formIsValid = false
      }

      if(this.formData.Status== null){
        this.invalidStatus = 'This field cannot left blanks'
        formIsValid = false
      }

      if(this.formData.Department == null){
        this.invalidDepartment= 'This field cannot left blanks'
        formIsValid = false
      }


      if(formIsValid){
        return true
      }
      else{
        return false
      }

    },

    ReportDownload:function (fileType){
      var component = this

      if(fileType=='PDF'){ component.pdfDownloading = true }
      else{ component.xlsxDownloading = true }

      let formData = new FormData()
      formData.append('file_type', fileType)
      formData.append('auth_token',component.$root.agentAuthToken)

      axios.post(component.$base_url+'/agent/reportDownload',formData)
          .then(function (response) {
            console.log(response)
            if(fileType=='PDF'){
              component.pdfDownloading = false
              component.generatePDF()
            }
            else{
              component.xlsxDownloading = false
              component.generateXLSX()
            }
          })
          .catch(function (error) {
            console.log(error)
            component.$buefy.toast.open({
              message: error.message,
              type: "is-danger",
            });
          });
    },

    generatePDF: function(){

      var component = this
      var doc = new jsPDF('l', 'px', 'a4')


      var headers = component.reportHeaders

      doc.setFontSize(22)
      doc.text(headers.reportTitle, 30, 30)

      doc.setTextColor(20)
      doc.setFontSize(10)
      doc.text('On ' + headers.reportGeneratedOn + ' by ' + headers.generatedBy , 30, 42)

      doc.setTextColor(0)
      doc.setFontSize(12)
      doc.text('Duration   :  ' + headers.selectedStartDate +' to '+ headers.selectedEndDate , 30, 60)
      // doc.text('User         :  '+ headers.selectedUser, 30, 84)


      doc.setFontSize(11)
      doc.setTextColor(100)

      var col = ['Username', 'Name','Department','Envelope Status','Timestamp']
      var rows = [];


      component.tableRows.forEach(element => {
        var temp = [element.username, element.name, element.department, element.status, this.DateFormat(element.created_at)];
        rows.push(temp);
      });

      doc.setProperties({
        title: headers.reportTitle,
        subject: headers.reportTitle
      });

      autoTable(doc,{
        head:[col],
        body:rows,
        title:headers.reportTitle,
        startY:100
      });

      // doc.autoTable({head:[col], body:rows, title: headers.reportTitle, startY: 100 });

      //doc.output('dataurlnewwindow') // for open in new window
      // var fileNameTimeStamp = headers.reportGeneratedOn.replace(/[ -]/g, '_')
      doc.save(headers.reportFileName + '.pdf') // for download file

    },

    submitForm: function(){

      var component = this
      this.formIsSubmitting = true

      var startd = this.selectedDateRange[0]
      var endd = this.selectedDateRange[1]

      // this is how use date for backend without messing up
      var start_date = startd.getFullYear()+"-"+(startd.getMonth()+1)+"-"+startd.getDate()
      var end_date = endd.getFullYear()+"-"+(endd.getMonth()+1)+"-"+endd.getDate()

      let formData = new FormData()
      formData.append('status',component.formData.Status)
      formData.append('department',component.formData.Department)
      formData.append('start_date',start_date)
      formData.append('end_date',end_date)
      formData.append('auth_token',component.$root.agentAuthToken,)

      axios.post(component.$base_url+'/agent/generateEnvelopeStatusReport',formData)
          .then(function (response) {
            console.log(response.data.data)
            component.tableRows = response.data.data.reportData
            component.reportHeaders = response.data.data.reportHeaders
            component.formIsSubmitting = false
            component.exportButtonsEnabled = true
          })
          .catch(function (error) {
            component.$buefy.toast.open({
              message: error.message,
              type: 'is-danger'
            })
            component.formIsSubmitting = false
          });

    },

    validateToken:function (){  //check authentication
      var component = this

      axios.post(component.$base_url+'/agent/checkAuthentication', {
        auth_token:component.$root.agentAuthToken
      })
          .then(function (data) {
            var array =[]
            array = data.data


            console.log(array.data.message)
            if(array.success == true){
              console.log(array.data.message)
              //load department & template ctg
              component.getDataList()

            }else{
              component.$buefy.toast.open({
                message: array.data.message,
                type: 'is-danger'
              })
              component.$router.push({name:'agentSignin'})
            }

          })
          .catch(function (error) {
            var array =[]
            array = error.response
            //session expired
            console.log(array.data.success)
            if(array.data.success == false){
              component.$buefy.toast.open({
                message: 'Authentication failed',
                type: 'is-danger'
              })
              component.$router.push({name:'agentSignin'})
            }
          });

    },


  },

  mounted (){

    // this.validateToken()
    var today = new Date();
    this.maxDate = today

  }
}

</script>

<style scoped>
/* Log Table Styles */

.log-icon-debug{color: #a2a2a2;}

.log-icon-info{color: #1facff;}

.log-icon-notice{color: #f7c200;}

.log-icon-warning{color: #f7c200;}
.log-description-warning{background-color: #fff795;color: #000;}

.log-icon-error{color: #ff0000;}
.log-description-error{color: #ff0000;}

.log-icon-critical{color: #ff0000;}
.log-description-critical{background-color: #f11d1d;color: #FFF;}

.log-icon-alert{color: #ff0000;}
.log-description-alert{background-color: #f11d1d;color: #FFF;}

.log-icon-emergency{color: #ff0000;}
.log-description-emergency{background-color: #f11d1d;color: #FFF;}
</style>

